import { api, TCustomAxiosResponse } from '..';
import { apiPaths } from '@/services/api/paths';
import { FeatureFlagDto, FeatureFlagsDto, UpdateFeatureFlagDto } from '@/types/generated/schemas';

export type TFeatureFlag = FeatureFlagDto;
export type TFeatureFlagKey = FeatureFlagDto['key'];

// Super-admin read of all product feature flags.
export const getAdminFeatureFlags = async (): Promise<TFeatureFlag[]> => {
  const { data } = await api.get<TCustomAxiosResponse<FeatureFlagsDto>>(apiPaths.featureFlags.admin);
  return data.data.flags;
};

// Super-admin update of one or more product feature flags. Blocked server-side while
// impersonating an organization (SuperAdminReadOnlyGuard).
export const updateFeatureFlags = async (flags: UpdateFeatureFlagDto[]): Promise<TFeatureFlag[]> => {
  const { data } = await api.patch<TCustomAxiosResponse<FeatureFlagsDto>>(apiPaths.featureFlags.admin, { flags });
  return data.data.flags;
};
